<template>
  <div></div>
</template>

<script>
import {vFormControls, defaultPanelVersion} from "@/enum";

let playMode = false;

function setItemPosition(item, event) {
  let x = (parseFloat(item.getAttribute("data-x")) || 0) + event.dx;
  let y = (parseFloat(item.getAttribute("data-y")) || 0) + event.dy;
  item.style.transform = "translate(" + x + "px, " + y + "px)";
  item.setAttribute("data-x", x);
  item.setAttribute("data-y", y);
}

function dragMoveListener(event) {
  if (!playMode) {
    let target = event.target;

    let clone = document.querySelector('.drag-clone');

    // translate the element
    if(clone) {
     setItemPosition(clone, event);
    } else {
     setItemPosition(target, event);
    }

    target = null;
  }
}

import interact from "interactjs";
import {hotspotPopupAllowedElementTypes} from "@/enum";
export default {
  name: "VformDraggableDroppableMixin",
  props: {},
  data() {
    return {
      draggableTargetBlock: ".draggable",
      draggableTargetElements: ".element-draggable",
      draggableTargetElementsHotspotPopup: ".element-draggable-popup",
      draggableTargetPanels: ".panel-container-default",
      draggableTargetPanelsNoBottom: '.panel-container-no-bottom',
      draggableInfoDot: ".hotspot-dot-container",
      bottomDropZoneAllowedElementTypes: [vFormControls.BUTTON, vFormControls.LOGOUT],
      hotspotPopupAllowedElementTypes,
      slideShowId: 'slideshow-inner'
    };
  },
  methods: {
    disableDragDropElements() {
      interact(this.draggableTargetBlock).unset();
      interact(this.draggableTargetElements).unset();
      interact(this.draggableTargetElementsHotspotPopup).unset();
      interact(this.draggableTargetPanels).unset();
      interact(this.draggableTargetPanelsNoBottom).unset();
      interact(this.draggableInfoDot).unset();
    },
    enableDragDropElements() {
      let $this = this;
      interact(this.draggableTargetBlock).unset();
      interact(this.draggableTargetBlock).draggable({
        inertia: true,
        modifiers: [
          interact.modifiers.restrict({
            restriction: ".vform-container-2",
            endOnly: true,
          }),
        ],
        autoScroll: true,
        listeners: {
          move: dragMoveListener,
          start(event) {
            playMode = $this.viewerModeOnly;
            if (!playMode) {
              let target = event.target;
              target.classList.add('i-am-dragging')
              let position = target.getBoundingClientRect();
              let flexer = document.getElementsByClassName('flexer');
              const parent = flexer[0];
              let parentEqualizer = 0;
              if (parent.classList.contains('panel-undocked')) {
                const parentPos = flexer[0].getBoundingClientRect();
                parentEqualizer = parentPos.top;
              }

              // if panel is undocked: apply transform of panel as well
              //target.style.transform = parent.style.transform;
              target.style.height = position.height + "px";
              target.style.width = position.width + "px";
              target.style.position = "fixed";
              target.style.top = (position.top - parentEqualizer) + "px";
              $this.state.dragging = true;

              target = null;
              flexer = null;
            }
          },
          end(event) {
            let target = event.target;
            target.classList.remove('i-am-dragging')
            target.style = {};
            target.setAttribute("data-x", 0);
            target.setAttribute("data-y", 0);
            $this.state.dragging = false;
            target = null;
          },
        },
      });

      //elements in panel tbd here
      interact(this.draggableTargetElements).unset();
      interact(this.draggableTargetElements).draggable({
        inertia: false,
        modifiers: [
          interact.modifiers.restrict({
            //restriction: "parent",
            endOnly: true,
          }),
        ],
        autoScroll: true,
        listeners: {
          move: dragMoveListener,
          start(event) {
              playMode = $this.viewerModeOnly;
              if (playMode) {
                return;
              }
            document.body.classList.add('no-select');

            $this.state.draggedElementUuid = event.target.getAttribute("element-uuid");
              $this.state.dragging = true;

              let {target} = event;

              console.log('mouseTop in start: ' + event.clientY)
              let clone = document.querySelector('.drag-clone');
              if (clone) {
                return;
              }
              clone = $this.applyElementDragStartStyle(target, event.clientX, event.clientY);
              $this.state.dragging = true;


          },
          end(event) {
            document.body.classList.remove('no-select');

            let target = event.target;
            let panelContainer = target.closest(".panel-container");
            if (panelContainer) {
              panelContainer.style.removeProperty("z-index");
            }

            //undo applied styles while dragging
            $this.applyElementDragEndStyle(target);
            $this.state.dragging = false;

            $this.state.draggedElementUuid = null;

            target = null;
          },
        },
      });

      //elements in popup
      interact(this.draggableTargetElementsHotspotPopup).unset();
      interact(this.draggableTargetElementsHotspotPopup).draggable({
        inertia: false,
        modifiers: [
          interact.modifiers.restrict({
            //restriction: "parent",
            endOnly: true,
          }),
        ],
        autoScroll: true,
        listeners: {
          move: dragMoveListener,
          start(event) {
            playMode = $this.viewerModeOnly;
            if (!playMode) {
              event.target.classList.add("element-dragging");
              event.target.style.transition = "revert";
              $this.state.dragging = true;
            }

            let target = event.target;
            $this.applyElementDragStartStyle(target, event.clientX, event.clientY);
            $this.state.draggedElementUuid = event.target.getAttribute("element-uuid");

            target = null;
          },
          end(event) {
            let target = event.target;

            //undo applied styles while dragging
            $this.applyElementDragEndStyle(target);
            $this.state.dragging = false;


            $this.state.draggedElementUuid = null;

            target = null;
          },
        },
      });

      // enable draggables to be dropped into this
      const dropZoneTarget = ".interactjs-drop-zone";
      interact(dropZoneTarget).unset();
      interact(dropZoneTarget).dropzone({
        // only accept elements matching this CSS selector
        accept: ".draggable, .element-draggable, .element-draggable-popup",
        // Require a 75% element overlap for a drop to be possible
        overlap: "pointer",

        ondropactivate: function (event) {
          // add active dropzone feedback
          event.target.classList.add("can-drop");
        },
        ondragenter: function (event) {
          const { target: dropzoneElement, relatedTarget: draggableElement } = event;
          dropzoneElement.classList.add("drop-active");
          dropzoneElement.classList.add("can-drop");
          let dropZoneId = dropzoneElement.getAttribute("dropZoneId");
          const elementType = draggableElement.getAttribute("elementType");

          if (dropZoneId && dropZoneId === "bottomDropZone") {
            if ($this.bottomDropZoneAllowedElementTypes.includes(elementType)) {
              dropzoneElement.classList.add("drop-active");
            } else {
              draggableElement.classList.add("drop-not-allowed");
              dropzoneElement.classList.add("drop-not-allowed");
            }
          } else {
            dropzoneElement.classList.add("drop-active");
          }

          // feedback the possibility of a drop
          //dropzoneElement.classList.add("drop-target");
          //draggableElement.classList.add("can-drop");
        },
        ondragleave: function (event) {
          // remove the drop feedback style
          event.target.classList.remove("drop-active");
          event.target.classList.remove("can-drop");
          event.target.classList.remove("drop-not-allowed");
          event.relatedTarget.classList.remove("drop-not-allowed");
        },
        ondrop: function (event) {
          let draggableElement = event.relatedTarget;
          draggableElement.classList.remove("block-drop-not-allowed");

          let elementType = draggableElement.getAttribute("element-type");
          let sourcePanelUuid = draggableElement.getAttribute("panel-uuid");
          let sourceElementUuid = draggableElement.getAttribute("element-uuid");

          let dropzoneElement = event.target;
          let hotspotForSlide = dropzoneElement.getAttribute("hotspotForSlide");
          let targetPanelUuid = dropzoneElement.getAttribute("panel-uuid");

          let previousElement = dropzoneElement.getAttribute("previous-element");
          let isFirst = dropzoneElement.getAttribute("is-first");
          let isLast = dropzoneElement.getAttribute("is-last");
          let isBottom = dropzoneElement.getAttribute("is-bottom");

          // todo: console log all attributes
          /*console.log('dropzoneElement', dropzoneElement)
          console.log('previousElement: ' + previousElement)
          console.log('isFirst: ' + isFirst)
          console.log('isLast: ' + isLast)
          console.log('isBottom: ' + isBottom)
          console.log('sourceElementUuid: ' + sourceElementUuid)*/

          if (hotspotForSlide) {
            if (draggableElement.classList.contains("element-draggable-popup")) {
              $this.moveOrAddElementToPanel('hotspot', {
                previousElement,
                isFirst,
                isLast,
                isBottom,
                existingElementUuid: sourceElementUuid,
                sourcePanelUuid: sourcePanelUuid
              });
            } else {
              $this.moveOrAddElementToPanel('hotspot', {
                previousElement,
                isFirst,
                isLast,
                isBottom,
                addingElementString: elementType,
              });
            }
          } else if (draggableElement.classList.contains("element-draggable")) {
            // drag and drop when reordering blocks or moving them from one panel to another
            $this.moveOrAddElementToPanel(targetPanelUuid, {
              previousElement,
              isFirst,
              isLast,
              isBottom,
              existingElementUuid: sourceElementUuid,
              sourcePanelUuid: sourcePanelUuid
            });
          } else {
            // drag and drop from blocks panel
            if (isBottom) {
              if (![$this.vFormControls.BUTTON, $this.vFormControls.LOGOUT].includes(elementType)) {
                return;
              }
            }
            $this.moveOrAddElementToPanel(targetPanelUuid, {
              previousElement,
              isFirst,
              isLast,
              isBottom,
              addingElementString: elementType,
            });
          }
          $this.state.dragging = false;
          dropzoneElement = null;
        },
        ondropdeactivate: function (event) {
          // remove active dropzone feedback
          event.target.classList.remove("drop-active");
          event.target.classList.remove("drop-not-allowed");
          event.relatedTarget.classList.remove("block-drop-not-allowed");
        },
      });
    },
    disableDragDropPanels() {
      interact(this.draggableTargetPanels).unset();
    },
    getSlideShowRectScale() {
      const element = document.getElementById(this.slideShowId);
      const {width, height} = element.getBoundingClientRect();
      return {
        scaleX: width / element.offsetWidth,
        scaleY: height / element.offsetHeight,
        width,
        height
      }
    },
    /**
     * This enables drag and drop functionality for panels inside of a step
     * @params {String} - itemClass - the class of the panel
     * @params {Boolean} - noBottomResize - whether or not to allow vertical scaling
     * */
    enableDragDropPanels(itemClass, noBottomResize = false) {
      let $this = this;
      interact(itemClass).unset();
      interact(itemClass)
          .draggable({
            inertia: true,
            modifiers: [
              interact.modifiers.restrict({
                endOnly: true,
              }),
            ],
            autoScroll: true,
            listeners: {
              move: dragMoveListener,
              start(event) {
                document.body.classList.add('no-select');
                let target = event.target;
                $this.$set($this.state, "panelDragging", true);
                target.classList.add("panel-dragging");
              },
              end(event) {
                document.body.classList.remove('no-select');
                let target = event.target;
                const targetRect = target.getBoundingClientRect();
                target.classList.remove("panel-dragging");
                const {scaleX, scaleY, width, height} = $this.getSlideShowRectScale();

                let newOffsetLeft = Number(target.offsetLeft) * scaleX + Number(target.getAttribute("data-x") * scaleX);
                if (newOffsetLeft < 0) {
                  newOffsetLeft = 0;
                }

                //if offset + width > parent width: snap it back
                let rightBoundary = newOffsetLeft + Number(targetRect.width);
                if (rightBoundary > width) {
                  newOffsetLeft = width - targetRect.width;
                }

                let newOffsetTop = Number(target.offsetTop) * scaleY + Number(target.getAttribute("data-y")) * scaleY;
                if (newOffsetTop < 0) {
                  newOffsetTop = 0;
                }


                console.log('new offset now: ' + newOffsetLeft)
                let percentageOffsetLeft =
                    (newOffsetLeft / width) * 100;
                let percentageOffsetTop =
                    (newOffsetTop / height) * 100;

                console.log('new percentage: ' + percentageOffsetLeft)

                target.style.transform = "";
                target.setAttribute("data-x", 0);
                target.setAttribute("data-y", 0);

                let step = $this.config.steps.find((x) => x.uuid === target.getAttribute("stepUuid"));
                if (step) {
                  let panel = step.panels.find((p) => p.uuid === target.getAttribute("panelUuid"));

                  if (!panel) {
                    //search in global panels
                    panel = $this.config.global.panels.find((p) => p.uuid === target.getAttribute("panelUuid"));
                  }

                  if (panel) {
                    $this.$set(panel, "xLeft", Math.round(percentageOffsetLeft));
                    $this.$set(panel, "y", Math.floor(percentageOffsetTop));
                    $this.$set(panel, "version", defaultPanelVersion);
                  }
                }

                step = null;
                target = null;
                $this.$set($this.state, "panelDragging", false);
              },
            },
          })
          .resizable({
            // resize from all edges and corners
            edges: {left: false, right: true, bottom: !noBottomResize, top: false},

            listeners: {
              start(event) {
                let target = event.target;
                target.setAttribute("data-start-width", event.rect.width);
                target.setAttribute("data-start-height", event.rect.height);
              },
              move(event) {
                document.body.classList.add('no-select');
                let target = event.target;
                target.classList.add("panel-dragging");
                let x = parseFloat(target.getAttribute("data-x")) || 0;
                let y = parseFloat(target.getAttribute("data-y")) || 0;

                const {scaleX, scaleY} = $this.getSlideShowRectScale();

                // update the element's style
                target.style.width = event.rect.width / scaleX + "px";
                target.style.height = event.rect.height / scaleY + "px";

                // translate when resizing from top or left edges
                x += event.deltaRect.left;
                y += event.deltaRect.top;

                target.style.transform = "translate(" + x + "px," + y + "px)";
                target.setAttribute("data-x", x);
                target.setAttribute("data-y", y);

                target = null;
              },
              end(event) {
                document.body.classList.remove('no-select');
                let {rect, target} = event;
                target.classList.remove("panel-dragging");
                //calculate panel.width and panel.height in percentages
                const {width, height} = $this.getSlideShowRectScale();

                let localWidth = (rect.width / width) * 100;
                let localHeight = (rect.height / height) * 100;

                const startWidth = parseFloat(target.getAttribute("data-start-width")) || 0;
                const startHeight = parseFloat(target.getAttribute("data-start-height")) || 0;

                target.style.transform = "";
                target.setAttribute("data-x", 0);
                target.setAttribute("data-y", 0);

                let step = $this.config.steps.find((x) => x.uuid === target.getAttribute("stepUuid"));
                if (step) {
                  let panel = step.panels.find((p) => p.uuid === target.getAttribute("panelUuid"));
                  if (!panel) {
                    //search in global panels
                    panel = $this.config.global.panels.find(
                        (p) => p.uuid === target.getAttribute("panelUuid")
                    );
                  }

                  if (panel) {
                    if(rect.width !== startWidth) {
                      $this.$set(panel, "width", Math.min(Math.ceil(localWidth), 100));
                    }
                    if(rect.height !== startHeight) {
                      $this.$set(panel, "height", Math.min(Math.ceil(localHeight), 100));
                    }
                  }
                }
                step = null;
                target = null;
              },
            },
            modifiers: [
              // keep the edges inside the parent
              interact.modifiers.restrictEdges({
                outer: "parent",
              }),
            ],

            inertia: true,
          });
    },
    applyElementDragStartStyle(target, clientX, clientY) {
      console.log('applying...')
      const MAX_DRAG_SIZE = 60;
      let { width, height, top, left } = target.getBoundingClientRect();

      const clampedWidth = Math.min(width, MAX_DRAG_SIZE);
      const clampedHeight = Math.min(height, MAX_DRAG_SIZE);

      // Center the clone on the cursor so the pointer is never visually offset
      const cloneLeft = clientX != null ? clientX - clampedWidth / 2 : left;
      const cloneTop  = clientY != null ? clientY - clampedHeight / 2 : top;

      let clone = target.cloneNode(true);
      clone.classList.add('drag-clone');
      clone.classList.add('element-dragging');
      document.body.appendChild(clone);
      clone.style.setProperty("position", "fixed", "important");
      clone.style.setProperty("left", cloneLeft + 'px', "important");
      clone.style.setProperty("top", cloneTop + 'px', "important");
      clone.style.setProperty("width", clampedWidth + "px", "important");
      clone.style.setProperty("height", clampedHeight + "px", "important");
      clone.style.setProperty("overflow", "hidden", "important");
      clone.style.setProperty("z-index", "2000", "important");
      clone.style.setProperty("transition", "none", "important");
      clone.style.setProperty("pointer-events", "none", "important");

      if (!target.style.paddingTop) {
        clone.style.setProperty("padding-top", "0px", "");
      }

      // todo: remove dropzone from clone (child element)
      let dropZone = clone.querySelector('.element-dropzone');
      if (dropZone) {
        dropZone.remove();
      }

      clone.classList.add("element-dragging");

      console.log(clone.getAttribute('element-uuid'))

      // Adjust overlay size, keep it fixed
      let overlay = clone.querySelector(".vform-viewer-editor-overlay");
      if (overlay) {
        overlay.style.height = clampedHeight + "px";
        overlay.style.width = clampedWidth + "px";
      }
      return clone;
    },
    applyElementDragEndStyle(target) {
      // Remove the clone
      let clone = document.querySelector('.drag-clone');
      if (clone) {
        clone.remove();
      }
      target.style.removeProperty("width");
      target.style.removeProperty("height");
      target.style.removeProperty("position");
      target.style.removeProperty("z-index");
      target.style.removeProperty("top");
      target.style.removeProperty("transition");
      target.style.removeProperty("transform");
      if (target.style.paddingTop === "0px") {
        target.style.removeProperty("padding-top");
      }

      target.setAttribute("data-x", 0);
      target.setAttribute("data-y", 0);
      target.classList.remove("element-dragging");
    },
  },
};
</script>
<style lang="scss">
.element-dragging {
  border: 1px solid var(--vform-editor-gizmos-primary-color);
  background-color: var(--vform-editor-gizmos-primary-color-brighter);
  .vform-viewer-editor-overlay {
    display: none !important;
  }
  &.vform-tiles {
    display: flex !important;
  }
  svg {
    display: none !important;
  }
}

.drag-clone {
  // size and pointer-events are applied inline in applyElementDragStartStyle
}

.panel-dragging {
  opacity: 0.8;
}
</style>
